import { createStore } from "vuex";

export default createStore({
    state: {
        bookingDetails_ferries: {
            "bookingId": 199999,
            "BookedArrivalDate": "2021-07-05",
            "BookedDeptDate": "2021-07-26",
            "weeks": 3,
            "AccomTypeID": "1",
            "ByoTypeID": null,
            "PriceTypeID": null,
            "deposit": 33,
            "accommodationPrice": "1270",
            "accommodation": "Luxury Tent",
            "CustomerID": 45859,
            "customer": {
                "Id": 45859,
                "TitleID": 1,
                "Name": "Test",
                "LastName": "Test",
                "DOB": "11/11/1999",
                "Postcode": "TN22 1QG",
                "House": "Glen View",
                "Street": "Glen Maye Hill-",
                "Town": "uefh TEST",
                "Locality": "Glen Maye",
                "County": "",
                "Country": "United Kingdom",
                "PassportCountry": "MK",
                "EMail": "test2@dzvezda.com",
                "gender": "M",
                "Phone": "test",
                "PhoneWork": "",
                "PhoneMob": ""
            },
            "companions": [{
                "Id": 45859,
                "TitleID": 1,
                "Name": "Test",
                "LastName": "Test",
                "DOB": "11/11/1999",
                "Postcode": "TN22 1QG",
                "House": "Glen View",
                "Street": "Glen Maye Hill-",
                "Town": "uefh TEST",
                "Locality": "Glen Maye",
                "County": "",
                "Country": "United Kingdom",
                "PassportCountry": "MK",
                "EMail": "test2@dzvezda.com",
                "gender": "M",
                "Phone": "test",
                "PhoneWork": "wedweded",
                "PhoneMob": "wedwed"
            }],
            "hire_items_price": 225,
            "transport_discount": 0,
            "hire_items": [{
                "232": "1",
                "236": "1",
                "1138": "2",
                "1892": "3"
            }],
            "additional_lines": [
                "Roof box",
                "Trailer; Length: 111cm; Width: 311cm",
                "Other information: 222e2e2e",
                "P&O Dover – Calais",
                "Outbound details: 309i 430ti0439ti043t0394i9034t0i34 0t9340t04i3 t0943it094 3it0 43t0i340t i0349it0934i09ti3409ti0934it0i3409ti0i43t",
                "Return details: 34t p34ot kpok3tpo34potk po34tkpo 34tkpo 4ktpok3 p4kto p3o4tkpo34 tkp kto4o34t"
            ],
            "insurance": {
                "insurance_provider": "Own insurance",
                "policy_number": "to follow",
                "emergency_phone": "to follow"
            },
            "ferries": {
                "ferry_option": "ferry",
                "ferry_items": [
                    "Roof box",
                    "Trailer",
                    "Other information"
                ],
                "trailer_length": "111",
                "trailer_height": "311",
                "caravan_length": null,
                "caravan_height": null,
                "other_information": "222e2e2e",
                "ferry_operator": "P&O Dover – Calais",
                "outbound_text": "309i 430ti0439ti043t0394i9034t0i34 0t9340t04i3 t0943it094 3it0 43t0i340t i0349it0934i09ti3409ti0934it0i3409ti0i43t",
                "return_text": "34t p34ot kpok3tpo34potk po34tkpo 34tkpo 4ktpok3 p4kto p3o4tkpo34 tkp kto4o34t"
            },
            "vehicles": [{
                    "Make": "afrferferf",
                    "Model": "erferferfr",
                    "Registration": "ferferfrf"
                },
                {
                    "Make": "erferfref",
                    "Model": "rferfref",
                    "Registration": "referferfref"
                }
            ],
            "discounts": {
                "referals_text": "referfoefij eorfjireoji",
                "referals_discount": "111",
                "lone_parents_discount": "11",
                "singles_and_couples": "",
                "promotional_discount_text": "doewi owefjoiwfj",
                "promotional_discount": "11"
            },
            "EnqSourceID": null
        },
        bookingDetails_stripe: {
            "bookingId": 200010,
            "BookedArrivalDate": "2021-07-05",
            "BookedDeptDate": "2021-07-19",
            "weeks": 2,
            "AccomTypeID": "35",
            "ByoTypeID": null,
            "PriceTypeID": null,
            "deposit": "100",
            "accommodationPrice": "2300",
            "accommodation": "Evergreen 2 deluxe",
            "CustomerID": 45859,
            "customer": {
                "Id": 45859,
                "TitleID": 1,
                "Name": "Test",
                "LastName": "Test",
                "DOB": "11/11/1999",
                "Postcode": "TN22 1QG",
                "House": "Glen View",
                "Street": "Glen Maye Hill-",
                "Town": "uefh TEST",
                "Locality": "Glen Maye",
                "County": "",
                "Country": "United Kingdom",
                "PassportCountry": "Macedonia",
                "EMail": "test2@dzvezda.com",
                "Phone": "test",
                "PhoneWork": "wedweded",
                "PhoneMob": "wedwed"
            },
            "companions": [],
            "hire_items_price": 75,
            "transport_discount": -60,
            "hire_items": [{
                "232": "1",
                "357": "1",
                "1138": "1"
            }],
            "additional_lines": [
                "",
                "Outbound details: ",
                "Return details: "
            ],
            "insurance": {
                "insurance_provider": "Own insurance",
                "policy_number": "to follow",
                "emergency_phone": "to follow"
            },
            "ferries": {
                "ferry_option": "notsure",
                "ferry_items": [],
                "trailer_length": null,
                "trailer_height": null,
                "caravan_length": null,
                "caravan_height": null,
                "other_information": null,
                "ferry_operator": "",
                "outbound_text": "",
                "return_text": ""
            },
            "vehicles": [{
                "Make": "aaa",
                "Model": "bbb",
                "Registration": "ccc"
            }],
            "discounts": {
                "referals_text": "ttttt",
                "referals_discount": "11",
                "lone_parents_discount": "22",
                "singles_and_couples": "",
                "promotional_discount_text": "pppp",
                "promotional_discount": "33"
            },
            "EnqSourceID": null
        },

        bookingDetails : {
            bookingId :null,
            BookedArrivalDate: null,
            BookedDeptDate: null,
            weeks:null,
            AccomTypeID: null,
            ByoTypeID: null,
            PriceTypeID: null,
            deposit: null,
            accommodationPrice: 0,
            accommodation: null,

            CustomerID: null,
            customer: null,
            // customer: { "Id": 45859, "TitleID": "", "Name": "Test", "LastName": "Test", "DOB": "1999-11-11", "Postcode": "7500", "House": "Glen View", "Street": "Glen Maye Hill-", "Town": "uefh TEST", "Locality": "Glen Maye", "County": "", "Country": "United Kingdom", "EMail": "test2@dzvezda.com", "Phone": "test", "PhoneWork": "", "PhoneMob": "" },
            companions: [],
            // companions: [{ "Id": "aaaa", "Name": "aaaa" }, { "Id": "bbbb", "Name": "bbbb" }, { "Id": "cccc", "Name": "cccc" }, { "Id": "dddd", "Name": "dddd" }, { "Id": "eeee", "Name": "eeee" } ],
            hire_items_price: 0,
            transport_discount: 0,
            // hire_items: [{ "232": "2", "357": "3", "1138": "5" }],
            hire_items: [],
            additional_lines: [],
            insurance: {
                insurance_provider: (bookingLangToInject == 'fr') ? 'nom de l’assureur' : 'Own insurance',
                policy_number :(bookingLangToInject == 'fr') ? 'à suivre' : 'to follow',
                emergency_phone :(bookingLangToInject == 'fr') ? 'à suivre' : 'to follow',
            },
            // ferries: {
            //     "ferry_option": "ferry",
            //     "ferry_items": [
            //         "Bikes on the roof",
            //         "Trailer",
            //         "Other information"
            //     ],
            //     "trailer_length": "11",
            //     "trailer_height": "22",
            //     "caravan_length": null,
            //     "caravan_height": null,
            //     "other_information": "other info",
            //     "ferry_operator": "P&O Dover – Calais",
            //     "outbound_text": "outbound details",
            //     "return_text": "return details"
            // },
            ferries: {
                ferry_option :null,
                ferry_items: [],
                trailer_length : null,
                trailer_height : null,
                caravan_length : null,
                caravan_height : null,
                other_information: null,
                ferry_operator :null,
                outbound_text:'',
                return_text:'',
            },
            // vehicles: [ { "Make":"make-1", "Model":"model-1", "Registration": "registration-1", }, { "Make":"make-2", "Model":"model-2", "Registration": "registration-2", } ],
            vehicles: [],
            discounts: {
                referals_text: '',
                referals_discount: '',
                lone_parents_discount: '',
                singles_and_couples: '',
                promotional_discount_text: '',
                promotional_discount: ''
            },
            EnqSourceID: null,
        },

        loadedAvailability: null,
        loadedDates: null,
        loadedExtras: null,
        loadedEnquirySources:null,
        loadedCountries:null,

        progressStep: 0,
        currency: bookingCurToInject,
        stripePublicKey:'-',
        currencyPopupShown: false,
    },
    mutations: {
        UPDATE_CURRENCY(state, payload) {
            state.stripePublicKey = (payload == 'GBP') ? stripePublicKeyGBP : stripePublicKeyEUR;
            console.log('currency------------->', payload == 'GBP', state.stripePublicKey);
            state.currencyPopupShown=true;
            state.currency = payload;
        },
        UPDATE_AVAILABILITY(state, payload) {
            if(payload!=null) {
                console.log('payload', payload );
                state.loadedAvailability = payload.accommodations;
                state.bookingDetails.bookingId = payload.bookingId;
                state.bookingDetails.BookedArrivalDate = payload.BookedArrivalDate;
                state.bookingDetails.BookedDeptDate = payload.BookedDeptDate;
            } else {
                state.loadedAvailability = null;
                state.bookingDetails.BookedArrivalDate = null;
                state.bookingDetails.BookedDeptDate = null;
            }
        },
        UPDATE_DATES(state, payload) {
            state.loadedDates = payload;
        },
        UPDATE_EXTRAS(state, payload) {
            state.loadedExtras = payload;
        },
        UPDATE_ENQUIRY_SOURCES(state, payload) {
            state.loadedEnquirySources = payload;
        },
        UPDATE_COUNTRIES(state, payload) {
            state.loadedCountries = payload;
        },
        UPDATE_HIRE_ITEMS(state, payload) {
            let newObj = JSON.parse(JSON.stringify(payload.items));
            // console.log('newObj',newObj);
            Object.keys(newObj).forEach(key => {
                if (newObj[key]==0) delete newObj[key];
            });
            // console.log('newObj',newObj);
            state.bookingDetails.hire_items = [];
            state.bookingDetails.hire_items.push(newObj);
            state.bookingDetails.hire_items_price=payload.price;
        },
        UPDATE_ACCOMMODATION_DETAILS(state, payload) {
            state.bookingDetails.BookedArrivalDate = payload.BookedArrivalDate;
            state.bookingDetails.BookedDeptDate = payload.BookedDeptDate;
            const dt1 = new Date(state.bookingDetails.BookedArrivalDate);
            const dt2 = new Date(state.bookingDetails.BookedDeptDate);
            
            state.bookingDetails.weeks = Math.ceil((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24 * 7));

            state.bookingDetails.AccomTypeID = payload.AccomTypeID;
            state.bookingDetails.ByoTypeID = payload.ByoTypeID;
            state.bookingDetails.PriceTypeID = payload.PriceTypeID;
            state.bookingDetails.accommodationPrice = payload.accommodationPrice;
            state.bookingDetails.accommodation = payload.accommodation;
            state.bookingDetails.deposit=null;
        },
        UPDATE_INSURANCE(state, payload) {
            state.bookingDetails.insurance.insurance_provider = payload.insurance_provider;
            state.bookingDetails.insurance.policy_number = payload.policy_number;
            state.bookingDetails.insurance.emergency_phone = payload.emergency_phone;
        },
        UPDATE_DEPOSIT(state, payload) {
            state.bookingDetails.deposit = payload;
        },

        UPDATE_DISCOUNTS(state, payload) {
            state.bookingDetails.discounts.referals_text = payload.referals_text;
            state.bookingDetails.discounts.referals_discount = payload.referals_discount;
            state.bookingDetails.discounts.lone_parents_discount = payload.lone_parents_discount;
            state.bookingDetails.discounts.singles_and_couples = payload.singles_and_couples;
            state.bookingDetails.discounts.promotional_discount_text = payload.promotional_discount_text;
            state.bookingDetails.discounts.promotional_discount = payload.promotional_discount;
        },
        UPDATE_FERRIES(state, payload) {
            // console.log(payload);
            // console.log('---->ferry items');
            // console.log('additional_lines', state.bookingDetails.additional_lines);
            // console.log('payload.ferry_items', payload.ferry_items);

            state.bookingDetails.ferries.ferry_option = payload.ferry_option;
            // console.log(payload);

            state.bookingDetails.transport_discount = 0;
            if(payload.ferry_option=='ferry') {
                state.bookingDetails.ferries.ferry_operator=payload.ferry_operator;
                state.bookingDetails.ferries.outbound_text=payload.outbound_text;
                state.bookingDetails.ferries.return_text=payload.return_text;
            } else {
                if (state.currency=='GBP') {
                    state.bookingDetails.transport_discount = -60;
                }
                state.bookingDetails.ferries.ferry_operator = '';
                state.bookingDetails.ferries.outbound_text = '';
                state.bookingDetails.ferries.return_text = '';
            }
            // console.log(state.transport_discount);

            state.bookingDetails.ferries.ferry_items = payload.ferry_items;

            state.bookingDetails.ferries.trailer_length = payload.trailer_length;
            state.bookingDetails.ferries.trailer_height = payload.trailer_height;
            state.bookingDetails.ferries.caravan_length = payload.caravan_length;
            state.bookingDetails.ferries.caravan_height = payload.caravan_height;
            state.bookingDetails.ferries.other_information = payload.other_information;

            //generiranje na additional lines
            state.bookingDetails.additional_lines=[];
            if (state.currency == 'GBP' && payload.ferry_option == 'ferry') {
                state.bookingDetails.ferries.ferry_items.forEach((element) => {
                    console.log(element);
                    let a = element;
                    if (a == 'Caravan') a += '; Length: ' + state.bookingDetails.ferries.caravan_length + 'cm; Width: ' + state.bookingDetails.ferries.caravan_height + 'cm';
                    if (a == 'Trailer') a += '; Length: ' + state.bookingDetails.ferries.trailer_length + 'cm; Width: ' + state.bookingDetails.ferries.trailer_height + 'cm';
                    if (a == 'Other information') a += ': ' + state.bookingDetails.ferries.other_information;
                    state.bookingDetails.additional_lines.push(a);
                });
                if(state.bookingDetails.ferries.ferry_operator!=null&&state.bookingDetails.ferries.ferry_operator!='')
                    state.bookingDetails.additional_lines.push(state.bookingDetails.ferries.ferry_operator);
                if(state.bookingDetails.ferries.outbound_text!=null&&state.bookingDetails.ferries.outbound_text!='')
                    state.bookingDetails.additional_lines.push('Outbound details: ' + state.bookingDetails.ferries.outbound_text);
                if(state.bookingDetails.ferries.return_text!=null&&state.bookingDetails.ferries.return_text!='')
                    state.bookingDetails.additional_lines.push('Return details: ' + state.bookingDetails.ferries.return_text);
            }

            console.log('------------------>additional lines');
            state.bookingDetails.additional_lines.forEach((element) => {
                console.log(element)
            });


        },
        CHANGE_PROGRESS_STEP(state, payload) {
            state.progressStep = payload;
        },
        CHANGE_ENQUIRY_SOURCE(state, payload) {
            state.bookingDetails.EnqSourceID = payload;
        },
        UPDATE_MAIN_BOOKER(state, payload) {
            state.bookingDetails.customer = payload;
            state.bookingDetails.CustomerID = payload.Id;
        },
        DELETE_COMPANION(state, payload) {
            state.bookingDetails.companions.splice(payload, 1);
        },
        INSERT_COMPANION(state, payload) {
            let newObj = JSON.parse(JSON.stringify(payload));
            let size = state.bookingDetails.companions.length;
            state.bookingDetails.companions[size]=newObj;
        },
        ADD_VEHICLE(state, payload) {
            let newObj = JSON.parse(JSON.stringify(payload));
            // console.log("ADD_VEHICLE",payload);
            state.bookingDetails.vehicles.push(newObj);
        },
        UPDATE_VEHICLE(state, payload) {
            // console.log("UPDATE_VEHICLE",payload.data.Make);
            // console.log("UPDATE_VEHICLE-index", payload.data);
            // console.log("UPDATE_VEHICLE-index", payload.index);
            console.log('old',state.bookingDetails.vehicles[payload.index]);
            state.bookingDetails.vehicles[payload.index].Make=payload.data.Make;
            state.bookingDetails.vehicles[payload.index].Model=payload.data.Model;
            state.bookingDetails.vehicles[payload.index].Registration=payload.data.Registration;
            console.log('new',state.bookingDetails.vehicles[payload.index]);
            // console.log(state.bookingDetails.vehicles[0]);
            //state.bookingDetails.companions.splice(payload, 1);
        },
        DELETE_VEHICLE(state, payload) {
            state.bookingDetails.vehicles.splice(payload, 1);
        },
    },
    actions: {},
    modules: {},
    getters: {
        getState: state => {
            return state;
        },
        getStripePublicKey: state => {
            return state.stripePublicKey;
        },
        getDiscounts: state => {
            return state.bookingDetails.discounts;
        },
        getBookingDetails: state => {
            return state.bookingDetails;
        },
        getProgressStep: state => {
            return state.progressStep;
        },
        getMainBooker: state => {
            return state.bookingDetails.customer;
        },
        getCompanions: state => {
            return state.bookingDetails.companions;
        },
        getHireItems: state => {
            return state.bookingDetails.hire_items;
        },
        getLoadedDates: state => {
            return state.loadedDates;
        },
        getLoadedCountries: state => {
            return state.loadedCountries;
        },
        getLoadedEnquirySources: state => {
            return state.loadedEnquirySources;
        },
        getLoadedExtras: state => {
            return state.loadedExtras;
        },
        getLoadedAvailability: state => {
            return state.loadedAvailability;
        },
        getVehicles: state => {
            return state.bookingDetails.vehicles;
        },
        getInsurance: state => {
            return state.bookingDetails.insurance;
        },
        getFerries: state => {
            return state.bookingDetails.ferries;
        },
        getCurrency: state => {
            return {
                'currency':state.currency,
                'symbol': (state.currency == 'EUR') ? '€' : '£',
                'PriceTypeID': (state.currency == 'EUR') ? pdID : 1,
                'popupShown': state.currencyPopupShown
            };
        },

    }
});
